function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 15 14",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.524,13.751l-0,-8.866l-2.949,-0l0,8.866l2.948,0l0.001,-0Zm10.628,-0l-0,-5.084c-0,-2.724 -1.455,-3.992 -3.393,-3.992c-1.566,0 -2.267,0.862 -2.657,1.465l0,-1.257l-2.947,-0c0.039,0.833 -0,8.868 -0,8.868l2.947,-0l0,-4.952c0,-0.265 0.019,-0.531 0.097,-0.718c0.212,-0.53 0.698,-1.078 1.511,-1.078c1.067,-0 1.496,0.812 1.496,2.004l0,4.744l2.947,0l-0.001,-0Zm-12.103,-10.078c1.028,-0 1.669,-0.682 1.669,-1.533c-0.019,-0.869 -0.641,-1.531 -1.648,-1.531c-1.01,-0 -1.668,0.663 -1.668,1.531c-0,0.852 0.64,1.534 1.629,1.534l0.018,-0.001Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.fe2b1ff1775173d887fbcf9f40deb49d.svg";
export { ForwardRef as ReactComponent };